import { DomWrapper } from "./DomWrapper";
import type { Node } from "../Core/Node";

export class CanvasWrapper extends DomWrapper {

    private _ctx: CanvasRenderingContext2D;

    get ctx(): CanvasRenderingContext2D { return this._ctx; }

    get htmlEle(): HTMLCanvasElement {
        return this._htmlEle as HTMLCanvasElement;
    }

    override setSize(size: { width?: number; height?: number; }): void {
        const { width, height } = size;

        if (width !== undefined) {
            this.htmlEle.width = width;
        }
        if (height !== undefined) {
            this.htmlEle.height = height;
        }
    }

    constructor(node: Node, htmlEle?: HTMLCanvasElement) {
        const canvas = htmlEle || document.createElement('canvas');
        super(node, canvas);
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            throw new Error('Failed to get 2d context from canvas');
        }
        this._ctx = ctx;
    }
}